import { SoundManagementRepository } from '../data/sound-management-repository';
import { MediaItem, UploadSoundRequest } from '../types/sound-management-types';

/**
 * Upload Sound Use Case
 * Handles uploading a new sound file
 */
export class UploadSoundUseCase {
  constructor(private readonly repository: SoundManagementRepository) {}

  async execute(request: UploadSoundRequest): Promise<MediaItem> {
    return this.repository.uploadSound(request);
  }
}
